import Swal from "sweetalert2";

type AlertType = "success" | "error" | "warning" | "info" | "question";

interface ToastOptions {
  icon: AlertType;
  title: string;
  text?: string;
  timer?: number;
  position?: "top" | "top-start" | "top-end" | "center" | "bottom" | "bottom-start" | "bottom-end";
}

export const showToast = ({
  icon,
  title,
  text,
  html,
  timer = 3000,
  position = "top-end",
}: {
  icon: "success" | "error" | "warning" | "info" | "question";
  title: string;
  text?: string;
  html?: string;
  timer?: number;
  position?: "top" | "top-start" | "top-end" | "center" | "bottom" | "bottom-start" | "bottom-end";
}) => {
  Swal.fire({
    toast: true,
    position,
    icon,
    title: `<b>${title}</b>`,
    text,
    html, // ✅ for custom list display
    timerProgressBar: true,
    timer,
    showConfirmButton: false,
  });
};
